export default __webpack_public_path__ + "static/media/tractive_1.3c92f88a.jpg";